import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { BaseCoreState, baseInquiryActions, baseInquirySelectors } from '../../../_store';
import { BaseCustomerInquiryOffersListPayloadInterface } from '../_interfaces/base-customer-inquiry-offers-list-payload.interface';
import { BaseHelpersService } from '../../../core/services/base-helpers.service';

@Injectable({ providedIn: 'root' })
export class BaseCustomerInquiryOffersGuard {
  constructor(private readonly store: Store<BaseCoreState>, private readonly router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    this.store
      .select(baseInquirySelectors.getCustomerInquiry)
      .pipe(
        filter((response) => response.ok !== undefined),
        take(1)
      )
      .subscribe((response) => {
        if (!response.data) {
          this.store.dispatch(baseInquiryActions.loadCustomerInquiry({ payload: route.params.inquiry }));
        } else {
          const payload: BaseCustomerInquiryOffersListPayloadInterface = {
            ...route.queryParams,
            experience: BaseHelpersService.stringToBoolean(route.queryParams.experience),
            inquiry: +route.params.inquiry,
            pinnedOfferId: this.router.getCurrentNavigation()?.extras?.state?.['pinnedOfferId'],
          };

          this.store.dispatch(baseInquiryActions.loadCustomerInquiryOffersList({ payload }));
        }
      });

    return this.store.select(baseInquirySelectors.getCustomerInquiryOffers).pipe(
      filter((response) => response.ok !== undefined),
      map((response) => !!response.ok)
    );
  }
}
